const AUTHORIZED = new Set(['authorized', 'requires_capture', 'captured']);

// Authorization is complete before Seller/Provider capture. Never require a
// captured payment at checkout, and never turn a refused card into success.
export const checkoutAuthorization = (response, count) => {
  const results = Array.isArray(response?.paymentAuthorizations) ? response.paymentAuthorizations : [];
  const products = Array.isArray(response?.products) ? response.products : [];
  if (results.some(line => line.error)) return { status: 'failed', error: results.find(line => line.error).error };
  const lines = results.length ? results : products.map(line => ({ status: line.payment?.status }));
  if (count > 0 && lines.length === count && lines.every(line => AUTHORIZED.has(line.status))) return { status: 'authorized' };
  return { status: 'pending' };
};
